import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LegalLayout from "../components/LegalLayout";
import SEO from "../components/SEO";
import { CONTACT } from "../data/mock";

export default function CookiePolicy() {
  useEffect(() => {
    document.title = "Cookie Policy – A.C.D.T.";
    window.scrollTo(0, 0);
  }, []);

  const reopen = () => {
    try {
      localStorage.removeItem("acdt_cookie_consent");
      window.location.reload();
    } catch (e) { /* noop */ }
  };

  return (
    <div className="relative overflow-x-hidden">
      <SEO />
      <Navbar />
      <LegalLayout title="Cookie Policy" lastUpdate="01 Giugno 2026">
        <Section title="Che cosa sono i cookie">
          <p>
            I cookie sono piccoli file di testo che i siti visitati inviano al terminale dell'utente,
            dove vengono memorizzati per essere ritrasmessi agli stessi siti alla successiva visita.
          </p>
        </Section>

        <Section title="Cookie utilizzati da questo sito">
          <p>Il sito {CONTACT.website} utilizza esclusivamente cookie tecnici necessari al funzionamento:</p>
          <ul>
            <li><strong>Cookie tecnici di sessione</strong>: necessari alla normale navigazione, non profilanti.</li>
            <li><strong>Cookie di preferenze</strong>: utilizzati per ricordare le scelte effettuate (es. consenso cookie banner).</li>
          </ul>
          <p>Non utilizziamo cookie di profilazione o di marketing senza esplicito consenso.</p>
        </Section>

        <Section title="Cookie di terze parti">
          <p>
            Le pagine che includono contenuti embeddati (es. post Facebook nella sezione Rassegna Stampa)
            possono impostare cookie di terze parti gestiti direttamente da Meta Platforms Inc.
            Per maggiori informazioni consulta la <a href="https://www.facebook.com/policies/cookies/" target="_blank" rel="noreferrer">Cookie Policy di Facebook</a>.
          </p>
        </Section>

        <Section title="Come gestire i cookie">
          <p>
            È possibile gestire le preferenze sui cookie direttamente dalle impostazioni del proprio browser.
            Per disabilitare o eliminare i cookie esistenti consulta le seguenti guide:
          </p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Apple Safari</a></li>
            <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer">Microsoft Edge</a></li>
          </ul>
          <p>
            Puoi anche revocare il consenso in qualsiasi momento cliccando sul pulsante qui sotto.
          </p>
          <button onClick={reopen} className="mt-2 inline-flex items-center px-4 py-2 rounded-lg bg-[#102a6b] hover:bg-[#0a1f55] text-white font-bold text-sm">
            Modifica preferenze cookie
          </button>
        </Section>

        <Section title="Riferimenti normativi">
          <p>
            La presente Cookie Policy è redatta in conformità al Regolamento UE 2016/679 (GDPR),
            al D.Lgs. 196/2003 (Codice Privacy) e al Provvedimento del Garante Privacy del 10 giugno 2021.
          </p>
        </Section>
      </LegalLayout>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="text-xl md:text-2xl font-extrabold text-[#0a1f55] mb-3">{title}</h2>
      <div className="text-[15px] text-slate-700 leading-relaxed space-y-3 [&_a]:text-[#102a6b] [&_a]:underline [&_a]:font-semibold [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:space-y-1.5 [&_ol]:space-y-1.5">
        {children}
      </div>
    </section>
  );
}
